
export default function run() {
    jQuery(function($){
        $(".toggle_menu").click(function () {
            $('#menu-menu-2').find('ul').removeClass("active_mobile_menu inactive_mobile_menu")
            $('#menu-menu-2').removeClass("active_mobile_menu inactive_mobile_menu")
            $(this).toggleClass("active")
            $('#menu-menu-2').toggleClass("active_menu")

        })
        $(".mobile_menu .menu-item-has-children:not(.back)>a").click(function (e) {
            e.preventDefault()
            $(this).toggleClass("active")
            $(this).next('.sub-menu').toggleClass("active_mobile_menu")
            $(this).closest('ul').toggleClass("inactive_mobile_menu")
        })
        $(".mobile_menu .back a").click(function (e) {
            e.preventDefault()
            $(this).closest('ul').toggleClass("active_mobile_menu")
            $(this).closest('.inactive_mobile_menu').removeClass("inactive_mobile_menu")
        })
    })
}



// WEBPACK FOOTER //
// ./template-parts/header/main-nav/script.js